import { ContinueYourBookingActivity } from 'component/page/home/ContinueYourBooking/ContinueYourBooking.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { getFormattedDate, getTodayDate } from 'core-framework/util/datetime/date';
import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import { getPax } from 'core/utils/getPax';
import { StringFormatter } from '@agoda/react-handyman';
import { ActivityContentMetaInfo, ContentMetaInfoPax, PerPaxBreakdown } from 'core/type/CuscoResponse.types';
import { parseISO } from 'date-fns';
import * as Logger from 'core/messaging/logger/logger';

export const getTravelerInfo = (activity: ContinueYourBookingActivity, cms: CmsValue): string => {
    const todayDate = getTodayDate();
    const showDate = todayDate < activity.travelDate;
    const dateFormat = getFormattedDate(activity.travelDate, cms, false, false);
    const totalPaxString = activity.pax.map((pax: { paxType: PaxTypeCode; quantity: number }) => getPax(cms, pax.quantity, pax.paxType));
    const paxFormat = StringFormatter.format(totalPaxString.join(' • '));

    return showDate ? `${dateFormat} • ${paxFormat}` : paxFormat;
};

const parsePerPaxBreakdown = (rawPerPaxBreakdown: string): ContentMetaInfoPax[] => {
    if (!rawPerPaxBreakdown) {
        return [];
    }
    try {
        const parsedData = JSON.parse(rawPerPaxBreakdown) as PerPaxBreakdown[];
        const result: ContentMetaInfoPax[] = parsedData.map((paxItem: PerPaxBreakdown) => ({
            paxType: paxItem.paxType as PaxTypeCode,
            quantity: paxItem.quantity,
        }));
        return result;
    } catch (error) {
        Logger.error(`Error parsing perPaxBreakdown: ${rawPerPaxBreakdown} with error`, error as Error);
        return [];
    }
};

export const parseContentMetaInfoToContinueYourBookingActivities = (rawContentMetaInfo: string): ContinueYourBookingActivity[] => {
    try {
        const parsedData = JSON.parse(rawContentMetaInfo) as ActivityContentMetaInfo[];

        // Map the JSON data to ContinueYourBookingActivities type
        const result: ContinueYourBookingActivity[] = parsedData.map((item: ActivityContentMetaInfo) => ({
            activityId: item.activity_id ? Number(item.activity_id) : -1,
            cityId: item.city_id ? Number(item.city_id) : -1,
            activityTitle: item.activity_title ?? '',
            activityImage: item.activity_image_url ?? '',
            enrichedOfferId: item.offer_id ? Number(item.offer_id) : -1,
            offerOptionId: item.offer_option_id != null ? Number(item.offer_option_id) : -1, // Can be zero so need to check for null
            travelDate: item.travel_date ? parseISO(item.travel_date) : getTodayDate(),
            pax: parsePerPaxBreakdown(item.per_pax_breakdown ?? ''),
        }));

        return result;
    } catch (error) {
        Logger.error(`Error parsing Continue Your Booking JSON string: ${rawContentMetaInfo} with error:`, error as Error);
        return [];
    }
};
